import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MdmCommandProgressService } from '@rocksoft/mdm-sdk-v2';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import { CommandContentActions, CommandContentApiActions } from './command-content.actions';

@Injectable()
export class CommandContentEffects {
  private readonly actions$ = inject(Actions);
  private readonly api = inject(MdmCommandProgressService);

  loadCommandContentEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CommandContentActions.commandContentRequested),
      mergeMap(({ udid, commandUuid }) =>
        safeMap(
          this.api.getCommandContent({ udid, commandUuid, apiVersion: '2.0' }),
          (commandContent) => CommandContentApiActions.commandContentLoaded({ commandContent }),
          (error) => CommandContentApiActions.commandContentLoadedError({ error })
        )
      )
    );
  });
}
